import { render, staticRenderFns } from "./CustomerDestinationAuthorization.vue?vue&type=template&id=ec1a423e"
import script from "./CustomerDestinationAuthorization.vue?vue&type=script&lang=js"
export * from "./CustomerDestinationAuthorization.vue?vue&type=script&lang=js"
import style0 from "./CustomerDestinationAuthorization.vue?vue&type=style&index=0&id=ec1a423e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports